import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './Article.css';
import zaneAvatar from '../assets/zane headshot.jpeg';
import { getArticleBySlug } from '../services/articleService';

function Article() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadArticle = async () => {
      setLoading(true);
      const result = await getArticleBySlug(slug);
      if (result.success) {
        setArticle(result.data);
      } else {
        console.error('Error loading article:', result.error);
        setArticle(null);
      }
      setLoading(false);
    };

    loadArticle();
  }, [slug]);

  if (loading) {
    return <div className="container">Loading...</div>;
  }

  if (!article) {
    return <div className="container">Article not found.</div>;
  }

  return (
    <div className="article-page">
      <div className="container">
        <Link to="/news" className="article-back">← Back to News</Link>
        <h1 className="article-headline">{article.title}</h1>
        <div className="article-date">{new Date(article.datePublished).toLocaleDateString()}</div>
        <div className="article-author">
          <img src={zaneAvatar} alt="Author headshot" className="article-author-avatar" />
          <span className="article-author-name">{article.author}</span>
        </div>
        <div className="article-content">
          {article.article.split('\n\n').map((para, idx) => (
            <p key={idx}>{para}</p>
          ))}
        </div>
        <Link to="/news" className="article-back">← Back to News</Link>
      </div>
    </div>
  );
}

export default Article; 